import { gql } from '@apollo/client';
import { SH_FIELD_FRAGMENT, ERROR_FRAGMENT } from './fragments.js';

export const GET_SH_FIELDS = gql`
  query GetShFields($structureId: ID, $type: String, $resourceType: String, $sportType: String) {
    MDB {
      id
      _SH_ {
        id
        fields(
          structureId: $structureId
          type: $type
          resourceType: $resourceType
          sportType: $sportType
        ) {
          ...ShFieldFields
        }
      }
    }
  }
  ${SH_FIELD_FRAGMENT}
`;

export const GET_SH_FIELD = gql`
  query GetShField($id: ID!) {
    MDB {
      id
      _SH_ {
        id
        field(id: $id) {
          ...ShFieldFields
        }
      }
    }
  }
  ${SH_FIELD_FRAGMENT}
`;

export const CREATE_SH_FIELD = gql`
  mutation CreateShField($input: _SH_FieldInput!) {
    _SH_createField(input: $input) {
      ok
      error {
        ...ErrorFields
      }
      field {
        ...ShFieldFields
      }
    }
  }
  ${SH_FIELD_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const UPDATE_SH_FIELD = gql`
  mutation UpdateShField($id: ID!, $input: _SH_FieldInput!) {
    _SH_updateField(id: $id, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      field {
        ...ShFieldFields
      }
    }
  }
  ${SH_FIELD_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const DELETE_SH_FIELD = gql`
  mutation DeleteShField($id: ID!) {
    _SH_deleteField(id: $id) {
      ok
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;
